<template>
  <div class="menu-list-container">
    <div class="page-header">
      <div class="page-title-block">
        <h2>菜单管理</h2>
        <p class="page-subtitle">配置系统左侧导航与工作台入口菜单</p>
      </div>
      <div class="header-actions">
        <el-button type="primary" @click="handleAdd">
          <i class="el-icon-plus"></i> 新增菜单
        </el-button>
      </div>
    </div>

    <el-card class="search-card">
      <div class="search-form">
        <el-form :inline="true" :model="searchForm" class="search-inline-form">
          <el-form-item label="菜单名称">
            <el-input v-model="searchForm.name" placeholder="请输入菜单名称" clearable @input="handleSearch" />
          </el-form-item>
          <el-form-item label="路由路径">
            <el-input v-model="searchForm.path" placeholder="例如 /customers" clearable @input="handleSearch" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">
              <i class="el-icon-search"></i> 搜索
            </el-button>
            <el-button @click="handleReset">
              <i class="el-icon-refresh"></i> 重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card>
      <!-- 桌面端表格 -->
      <el-table
        v-if="!isMobile"
        :data="filteredMenus"
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="name" label="菜单名称" min-width="150" />
        <el-table-column prop="path" label="路由路径" min-width="180" />
        <el-table-column prop="icon" label="图标" min-width="140">
          <template slot-scope="scope">
            <i v-if="scope.row.icon" :class="scope.row.icon" style="margin-right:6px" />{{ scope.row.icon }}
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序号" width="90" />
        <el-table-column prop="visible" label="是否显示" width="90">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.visible ? 'success' : 'info'"
              size="mini"
              class="visible-tag"
            >
              {{ scope.row.visible ? '显示' : '隐藏' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="190" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" type="success" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 手机端卡片列表 -->
      <div v-else class="menu-mobile-list">
        <div
          v-for="item in filteredMenus"
          :key="item.id"
          class="menu-mobile-card"
        >
          <div class="menu-mobile-main">
            <div class="menu-mobile-name">
              <i v-if="item.icon" :class="item.icon" class="menu-mobile-icon"></i>
              <span>{{ item.name || '未命名菜单' }}</span>
            </div>
            <div class="menu-mobile-path">
              路由：{{ item.path || '-' }}
            </div>
            <div class="menu-mobile-meta">
              <span>排序：{{ item.sortOrder != null ? item.sortOrder : 0 }}</span>
              <span class="menu-mobile-visible">
                <el-tag
                  :type="item.visible ? 'success' : 'info'"
                  size="mini"
                  class="visible-tag"
                >
                  {{ item.visible ? '显示' : '隐藏' }}
                </el-tag>
              </span>
            </div>
          </div>
          <div class="menu-mobile-actions">
            <el-button size="mini" type="success" @click="handleEdit(item)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(item)">删除</el-button>
          </div>
        </div>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :width="isMobile ? '90%' : '520px'">
      <el-form :model="menuForm" :rules="menuRules" ref="menuForm" label-width="100px">
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model="menuForm.name" placeholder="请输入菜单名称" />
        </el-form-item>
        <el-form-item label="路由路径" prop="path">
          <el-input v-model="menuForm.path" placeholder="例如 /customers 或 /roles" />
        </el-form-item>
        <el-form-item label="图标 class" prop="icon">
          <el-input v-model="menuForm.icon" placeholder="例如 el-icon-s-custom" />
        </el-form-item>
        <el-form-item label="排序号" prop="sortOrder">
          <el-input-number v-model="menuForm.sortOrder" :min="0" :max="999" />
        </el-form-item>
        <el-form-item label="是否显示" prop="visible">
          <el-switch v-model="menuForm.visible" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'MenuList',
  data() {
    return {
      menus: [],
      filteredMenus: [],
      isMobile: false,
      dialogVisible: false,
      isEditMode: false,
      dialogTitle: '',
      searchForm: {
        name: '',
        path: ''
      },
      menuForm: {
        id: '',
        name: '',
        path: '',
        icon: '',
        sortOrder: 0,
        visible: true
      },
      menuRules: {
        name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
        path: [{ required: true, message: '请输入路由路径', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.loadMenus()
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768
    },
    loadMenus() {
      request.get('/menus')
        .then(res => {
          this.menus = res.data || res
          this.filteredMenus = this.menus
        })
        .catch(err => {
          console.error('加载菜单列表失败:', err)
          this.$message.error('加载菜单列表失败')
        })
    },
    handleSearch() {
      let list = [...this.menus]
      if (this.searchForm.name) {
        list = list.filter(m => m.name && m.name.includes(this.searchForm.name))
      }
      if (this.searchForm.path) {
        list = list.filter(m => m.path && m.path.includes(this.searchForm.path))
      }
      this.filteredMenus = list
    },
    handleReset() {
      this.searchForm = { name: '', path: '' }
      this.filteredMenus = this.menus
    },
    handleAdd() {
      this.isEditMode = false
      this.dialogTitle = '新增菜单'
      this.menuForm = {
        id: '',
        name: '',
        path: '',
        icon: '',
        sortOrder: 0,
        visible: true
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.menuForm && this.$refs.menuForm.resetFields()
      })
    },
    handleEdit(row) {
      this.isEditMode = true
      this.dialogTitle = '编辑菜单'
      this.menuForm = {
        id: row.id,
        name: row.name,
        path: row.path,
        icon: row.icon,
        sortOrder: row.sortOrder,
        visible: row.visible
      }
      this.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm(`确定要删除菜单 "${row.name}" 吗？`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.delete(`/menus/${row.id}`)
          .then(() => {
            this.$message.success('删除菜单成功')
            this.loadMenus()
          })
          .catch(err => {
            console.error('删除菜单失败:', err)
            this.$message.error('删除菜单失败')
          })
      }).catch(() => {})
    },
    handleSubmit() {
      this.$refs.menuForm.validate(valid => {
        if (!valid) return
        const payload = { ...this.menuForm }
        const req = this.isEditMode
          ? request.put(`/menus/${payload.id}`, payload)
          : request.post('/menus', payload)
        req.then(() => {
          this.$message.success(this.isEditMode ? '编辑菜单成功' : '新增菜单成功')
          this.dialogVisible = false
          this.loadMenus()
        }).catch(err => {
          console.error('保存菜单失败:', err)
          this.$message.error('保存菜单失败')
        })
      })
    }
  }
}
</script>

<style scoped>
.menu-list-container {
  width: 100%;
}

/* 是否显示列：强制背景+文字对比度，保证本地与正式环境一致可读 */
.menu-list-container .visible-tag.el-tag--success {
  background-color: #17b676 !important;
  border-color: #17b676 !important;
  color: #fff !important;
}
.menu-list-container .visible-tag.el-tag--info {
  background-color: #909399 !important;
  border-color: #909399 !important;
  color: #fff !important;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  padding: 14px 4px 6px;
}

.page-title-block h2 {
  margin: 0;
  font-size: 22px;
  color: #0f8f59;
}

.page-subtitle {
  margin-top: 4px;
  font-size: 12px;
  color: #80848f;
}

.search-card {
  margin-bottom: 20px;
}

.search-inline-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.menu-mobile-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.menu-mobile-card {
  border-radius: 10px;
  border: 1px solid #ebeef5;
  padding: 10px 12px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(15, 159, 215, 0.04);
}

.menu-mobile-main {
  margin-bottom: 8px;
}

.menu-mobile-name {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
  gap: 6px;
}

.menu-mobile-icon {
  font-size: 16px;
}

.menu-mobile-path {
  margin-top: 2px;
  font-size: 12px;
  color: #909399;
  word-break: break-all;
}

.menu-mobile-meta {
  margin-top: 4px;
  font-size: 12px;
  color: #606266;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.menu-mobile-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}

@media (max-width: 768px) {
  .menu-list-container {
    padding: 0 4px;
  }
  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .search-inline-form {
    flex-direction: column;
  }
  .menu-mobile-actions {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}
</style>

